<template>
    <div class="top-controls">
        <div class="columns">
            <div class="column is-6">
                <div class="has-text-grey is-clickable is-vcentered" @click="restartConfigurator">
                    <span>&lt;- Konfiguration neustarten</span>
                </div>
            </div>
            <div class="column is-6 has-text-right">
                <div class="" v-if="currentStep === 'Summary'">
                    <button :disabled="cart.length === 0" class="button is-primary" @click="orderModalOpen = true"><span class="item-count">{{ cart.length }}</span>Auftragsanfrage</button>
                    <OrderModal v-if="orderModalOpen" @close="orderModalOpen = false" />
                </div>
                <div v-else class="">
                    <button :disabled="cart.length === 0" class="button is-primary" @click="goToSummary"><span class="item-count">{{ cart.length }}</span>Zusammenfassung</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import OrderModal from '@/components/modals/OrderModal'


export default {
    components: { OrderModal },
    props: {},
    data () {
        return {
            orderModalOpen: false
        }
    },
    computed: {
        cart () {
            return this.$store.state.cart
        },
        currentStep: {
            set (val) {
                this.$store.commit('setCurrentStep', val)
            },
            get () {
                return this.$store.state.currentStep
            }
        },
        currentProduct: {
            set (val) {
                this.$store.commit('setCurrentProduct', val)
            },
            get () {
                return this.$store.state.currentProduct
            }
        }
    },
    methods: {
        goToSummary () {
            this.currentStep = 'Summary'
        },
        restartConfigurator () {
            this.currentProduct = null
            this.currentStep = 'Unterkonstruktion'
        }
    }
}
</script>

<style lang="sass" scoped>
.item-count
    border-radius: 50%
    display: grid
    place-items: center
    width: 30px
    height: 30px
    background: white
    color: black
    margin-right: 10px

.top-controls
    margin: 10px 10px
</style>